import Vue from 'vue'
import _ from 'lodash'
import * as components from '../components/_global/*.vue'
import * as directives from '../directives/*.js'

_.map(components, (component) => {
	Vue.component(component.name, component)
})

_.map(directives, (directive) => {
	Vue.directive(directive.name, directive)
})

export default {}



// WEBPACK FOOTER //
// ./src/initializers/autoload.js